/**
 * Web Vitals reporting to Google Analytics 4
 * 
 * Metrics tracked:
 * - LCP (Largest Contentful Paint) - Loading performance
 * - FID (First Input Delay) - Interactivity  
 * - CLS (Cumulative Layout Shift) - Visual stability
 * - TTFB (Time to First Byte) - Server response
 * - INP (Interaction to Next Paint) - Responsiveness
 * 
 * View in GA4: Reports → User Experience → Core Web Vitals
 * Or in Google Search Console: Experience → Core Web Vitals
 */

import { gaEvent } from './analytics';

const sendToGoogleAnalytics = ({ name, delta, value, id }) => {
  // Gated: production hostname only, safe no-op
  gaEvent(name, {
    // Use delta (change) for accurate cumulative metrics like CLS
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    // Custom parameters for detailed analysis
    event_category: 'Web Vitals',
    event_label: id,
    // Non-interaction event (doesn't affect bounce rate)
    non_interaction: true,
    // Additional context
    metric_value: value,
    metric_delta: delta,
  });
};

export const reportWebVitals = async () => {
  try {
    const { onLCP, onFID, onCLS, onTTFB, onINP } = await import('web-vitals');
    
    // Core Web Vitals (affect SEO rankings)
    onLCP(sendToGoogleAnalytics);   // Largest Contentful Paint
    onFID(sendToGoogleAnalytics);   // First Input Delay
    onCLS(sendToGoogleAnalytics);   // Cumulative Layout Shift
    
    // Additional metrics
    onTTFB(sendToGoogleAnalytics);  // Time to First Byte
    onINP(sendToGoogleAnalytics);   // Interaction to Next Paint
  } catch (error) {
    // Silently fail if web-vitals can't load
    console.debug('Web Vitals not available:', error);
  }
};

export default reportWebVitals;
